/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';
import type { CallApi } from 'utils/ajax';
import { fetchProjects, projectIsSubmitting } from 'ducks/projects';
import type { Options } from 'ducks/workflow';
import withRouting from 'utils/withRouting';

type WorkflowOptions = {
  action(opts: Options): CallApi
}

type Props = {
  dispatch(): any,
  program: string,
  project: string,
  projects: {items: [Object]}, // need common types
  closeModal: () => {},
  isFetching: boolean,
  projectData: Object
}

type State = {
  isFetching: boolean
}

export default function workflow({action}: WorkflowOptions): any {
  return function wrapComponent(ComposedComponent: any) {
    class WorkflowContainer extends React.Component<void, Props, State> {

      componentDidUpdate(prevProps) {
        if (prevProps.isFetching !== this.props.isFetching && !this.props.isFetching) {
          this.props.dispatch(fetchProjects({ ids: this.props.projects.items.map(x => x.project_id) }));
        }
      }

      async handleOnClick({ dispatch, closeModal }, program, project) {
        if (closeModal) closeModal();
        if (action.name === 'submit') {
          dispatch(projectIsSubmitting(`${program}-${project}`, true));
        }

        dispatch(action({program, project}));
      }

      render() {
        const { program, project } = this.props?.router?.params;
        const projectData = this.props.projects.items.find(p => p.project_id === `${program}-${project}`);

        return (
          <ComposedComponent
            isFetching={this.props.isFetching}
            projectData={projectData}
            handleOnClick={() => this.handleOnClick(this.props, program, project)}
            {...this.props}
          />
        );
      }
    }

    return connect(
      ({
        projects,
        workflow: { isFetching },
      }) => ({projects, isFetching })
    )(withRouting(WorkflowContainer));
  };
}
